import React from 'react';
import {determinePausedTooltipText} from '../../utils/banTypeClassifier';
import Tooltip from 'app/Components/Shared/Tooltip/Tooltip';
import {BanTypeEnum} from '../../Constants/banTypeEnum';
import ProductDescription from '../ProductDescription';
import Image from 'app/Components/Shared/Image/image';

const BanStatusHeader = ({ban}) => {
  const showTooltip = () => {
    switch (ban.banType) {
      case BanTypeEnum.BAN_WITH_DEBT:
      case BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX:
      case BanTypeEnum.BAN_WITHOUT_PAYMENT_METHOD:
        return true;
      default:
        return false;
    }
  };

  return (
    <div className='ban-status-header'>
      <div className='ban-status-header__info'>
        <span className='ban-status-header__number'>חשבון {ban.banNumber}</span>
        {ban.productDescriptions && (
          <ProductDescription
            productDescriptions={ban.productDescriptions}
            banNumber={ban.banNumber}
            className='ban-status-header__name'
            tooltipIdPrefix='ban-status-header'
          />
        )}
      </div>
      {showTooltip() && ban.paused && (
        <div className='suspended-ban-tooltip'>
          <div className='suspended-ban-tooltip-title' id={`suspended-ban-${ban.banNumber}`}>
            חשבון מושהה
            <Image src={require('../../images/tooltip.svg')} alt='icon' />
          </div>
          <Tooltip
            title={''}
            text={determinePausedTooltipText(ban)}
            target={`suspended-ban-${ban.banNumber}`}
            placement={'top'}
            cellcomdefault={true}
            offsetRight={50}
            showCloseButton={true}
          />
        </div>
      )}
    </div>
  );
};

export default BanStatusHeader;
